import React, { lazy, Suspense, useEffect } from 'react';
import Buffering from './Buffering';
// import OurWorkContent from './OurWorkContent';
// import PageHeader from './PageHeader';


const PageHeader = lazy(() => import('./PageHeader'));

const OurWorkContent = lazy(() => import('./OurWorkContent'));

export default function OurWork() {
  useEffect(()=>{
    window.scrollTo(0,0);
},[]);
  return (
    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 row px-0 display-flex'>
      <Suspense fallback={<Buffering />}>
      <PageHeader title="Our Portfolio" endPoint = "OUR PORTFOLIO" />
      <OurWorkContent />
      </Suspense>
    </div>
  )
}
